import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

//import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import store from './store'

createApp(App)
  .use(router)
  //.use(config)
  .use(store)
  .component('fa', FontAwesomeIcon)
  .mount('#app')
